import View from './ManageAccount.view';

export default View;
